import { useEffect, useState } from "react";
import { useEditorMaybe } from "@grapesjs/react";
import { Button, Form } from "react-bootstrap";

import ChooseSelector from "../ChooseSelector/ChooseSelector.jsx";
import { editorStyleSelectSelectorForCurrentDevice, handleStyleUpdate } from "../../helpers/parentChildSelectorHelpers.js";

const ParentChildSelector = () => {
  const editor = useEditorMaybe();

  const [parentClasses, setParentClasses] = useState([]);
  const [isParentChildModeActivated, setParentChildModeActivated] = useState(false);

  const updateSelectorLabel = (targetSelectors) => {
    setTimeout(() => {
      const parentClassesMappedToString = parentClasses.map((parentClass) => `<span class="parent-selector">${parentClass}</span>`).join(" ");
      // console.log("selector change", parentClasses.join(" "), targetSelectors);
      document.querySelector(
        "#selector-container span.gjs-clm-sel"
      ).innerHTML = `<span class="gjs-clm-sel-rule">${parentClassesMappedToString} ${targetSelectors}</span>`;
    }, 5);
  };

  function handleSelectorChange() {
    setTimeout(() => {
      const targetSelectors = editor.getSelectedToStyle().selectorsToString();
      // editor.StyleManager.select(`${parentClasses.join(" ")} ${targetSelectors}`);
      editorStyleSelectSelectorForCurrentDevice(editor, `${parentClasses.join(" ")} ${targetSelectors}`);

      updateSelectorLabel(targetSelectors);
    }, 10);
  }

  const handleActivationParentChild = () => {
    setParentChildModeActivated((isParentChildModeActivated) => !isParentChildModeActivated);
  };

  const handleAddParentSelector = () => {
    const targetToStyle = editor.getSelectedToStyle();

    if (editor.DomComponents.isComponent(targetToStyle)) {
      alert("Please ensure at least one class is present for the parent selector.");
      return;
    }

    const targetSelectors = targetToStyle.selectorsToString();
    setParentClasses((parentClasses) => [...parentClasses, targetSelectors]);
  };

  const handleRemoveParentSelector = (e) => {
    const indexToRemove = parseInt(e.currentTarget.dataset.index);
    setParentClasses((parentClasses) => parentClasses.filter((parentClass, index) => index !== indexToRemove));
  };

  useEffect(() => {
    try {
      if (editor) {
        if (isParentChildModeActivated) {
          handleSelectorChange();

          editor.on("selector", handleSelectorChange);
          editor.on("component:selected", handleSelectorChange);
          editor.on("device:select", handleSelectorChange);
        } else {
          setParentClasses([]);
          const selectedComponent = editor.getSelected();
          editor.selectRemove(selectedComponent);
          editor.select(selectedComponent);

          console.log("useffect");
          editor.off("component:styleUpdate", handleStyleUpdate);
        }

        return () => {
          // console.log("useffect-return");
          editor.off("selector", handleSelectorChange);
          editor.off("component:selected", handleSelectorChange);
          editor.off("device:select", handleSelectorChange);
        };
      }
    } catch (err) {
      console.log(err);
    }
  }, [parentClasses.length, isParentChildModeActivated]);

  if (!editor) return <></>;

  return (
    <>
      <div className="parent-child-selector p-1">
        <div
          className="mb-2 d-flex justify-content-evenly"
          title="Create Parent-Child Selector Rule"
        >
          <label className="small fw-semibold">
            <i className="fa-solid fa-sitemap fa-2x" />
          </label>
          <Form.Switch
            id="parent-child-switch"
            checked={isParentChildModeActivated}
            onChange={handleActivationParentChild}
          ></Form.Switch>
        </div>
        {isParentChildModeActivated ? (
          <>
            <div className="mb-2 mx-auto add-parent-child-selector">
              <small>Make Current selected element as parent:</small>
              <Button
                size="sm"
                variant="primary"
                className="p-1"
                onClick={handleAddParentSelector}
              >
                <i className="fa-solid fa-circle-plus small" />
              </Button>
            </div>
            <div className="mb-2">
              {parentClasses.length > 0 &&
                parentClasses.map((parentClass, index) => (
                  <div
                    key={`${parentClass}-${index}`}
                    style={{ fontSize: "13px" }}
                    className="bg-primary text-white m-1 p-1 rounded"
                  >
                    {parentClass}{" "}
                    <Button
                      data-index={index}
                      size="sm"
                      variant="danger"
                      className="p-1"
                      onClick={handleRemoveParentSelector}
                    >
                      <i className="fa-solid fa-trash-can" />
                    </Button>
                  </div>
                ))}
            </div>
          </>
        ) : (
          <ChooseSelector />
        )}
      </div>
    </>
  );
};

export default ParentChildSelector;
